import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadingCloseToHalf = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 22 22",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#F2F2F2",
		d: "M11 0a11 11 0 1 0 7.075 19.423l-1.77-2.107A8.247 8.247 0 1 1 11 2.75z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 0a11 11 0 0 1 6.466 19.9l-1.618-2.227A8.249 8.249 0 0 0 11 2.751z"
	})]
});
export default SvgLoadingCloseToHalf;
